import { Grid, GridItem, Link, Nowrap, Section } from '@farmersdog/corgi-x';
import { getLinkToFreshSignup } from '@farmersdog/tosa/src/utils/getLinkToSignupFlow';
import {
  CtaTrackerV2,
  ReviewsRedesignSections,
} from 'src/pages/HomepageRedesign/components/CtaTrackerV2';
import { ExtendedButton } from 'src/pages/HomepageRedesign/components';

import { ExtendedText } from 'src/pages/HomepageRedesign/components/ExtendedText';
import { PATH_SIGNUP_ME } from '@farmersdog/constants/paths';
import styles from './ReviewsHero.module.css';
import { FiveStarsIcon } from './assets';
import { ImageMarqueeMobile } from './ImageMarqueeMobile';
import { ImageMarqueeDesktop } from './ImageMarqueeDesktop';

import { DiscountType, useCoupon } from '@farmersdog/coupons';
import config from 'src/config';

export const ReviewsHero = () => {
  const linkToFreshSignup = getLinkToFreshSignup(PATH_SIGNUP_ME);

  const { url, referrerRoute } = config('tosa.app.coreApi');

  const { discountAmount } = useCoupon({
    apiUrl: `${url}${referrerRoute}`,
    defaultDiscount: {
      discountType: DiscountType.percentage,
      discountAmount: config('features.defaultTrialDiscount'),
    },
  });
  const ctaLabel = `Get ${discountAmount}% Off Fresh Food`;

  // TODO: Verify this link is correct
  const googleReviewsLink =
    "https://www.google.com/maps/place/The+Farmer's+Dog/@40.7324984,-74.0109989,17.63z/data=!3m1!5s0x89c25986736c44fd:0xfebc3d1ad921115d!4m18!1m9!3m8!1s0x89c2599fda822e7b:0x1f3c21784965e32e!2sThe+Farmer's+Dog!8m2!3d40.7294695!4d-74.0001352!9m1!1b1!16s%2Fg%2F11pf3nq72d!3m7!1s0x89c2599fda822e7b:0x1f3c21784965e32e!8m2!3d40.7294695!4d-74.0001352!9m1!1b1!16s%2Fg%2F11pf3nq72d?entry=ttu&g_ep=EgoyMDI1MDQwMi4xIKXMDSoASAFQAw%3D%3D";

  return (
    <Section
      aria-labelledby="reviews-hero-heading"
      bottomSpacing="md"
      backgroundColor="ChickpeaExperimental"
      className={styles.root}
      widthConstraint="xl"
    >
      {/* Hidden on `lg` screens via CSS */}
      <ImageMarqueeMobile />

      <Grid>
        <GridItem xs={12} lg={5} className={styles.contentGridItem}>
          <div>
            <ExtendedText
              bottomSpacing="sm"
              as="h1"
              variant="heading-36"
              color="Kale3"
              weight="black"
              className={styles.heading}
              id="reviews-hero-heading"
            >
              Billions of meals.
              <br />
              Millions of reviews.
            </ExtendedText>
            <ExtendedText
              as="h2"
              variant="heading-16"
              color="Kale3"
              weight="semibold"
              bottomSpacing="xl"
              className={styles.subheading}
            >
              From picky pups to senior dogs, meet the dogs loving their
              <Nowrap>fresh food.</Nowrap>
            </ExtendedText>
            <CtaTrackerV2
              type="select"
              moduleLevel={1}
              moduleName={ReviewsRedesignSections.Hero}
            >
              <ExtendedButton
                variant="solid-kale-2"
                type="link"
                to={linkToFreshSignup}
                className={styles.cta}
              >
                {ctaLabel}
              </ExtendedButton>
            </CtaTrackerV2>
            <br />
            <Link to={googleReviewsLink} target="_blank">
              <FiveStarsIcon aria-label="Five stars" />
              <ExtendedText
                color="Kale3"
                variant="heading-16"
                weight="bold"
                leftSpacing="sm"
              >
                Google Reviews
              </ExtendedText>
            </Link>
          </div>
        </GridItem>

        <GridItem lg={7}>
          {/* Visible on `lg` screens via CSS */}
          <ImageMarqueeDesktop />
        </GridItem>
      </Grid>
    </Section>
  );
};
